import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { authErrorMessage } from '../lib/authErrors';
import { TerminalSquare, Loader2 } from 'lucide-react';

const BG = 'https://images.unsplash.com/photo-1762279389042-9439bfb6c155?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3Nzc5MjI3MTF8MA&ixlib=rb-4.1.0&q=85';

export default function Signup() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            toast.error('Şifre en az 6 karakter olmalı');
            return;
        }
        setLoading(true);
        try {
            await register(email, password, name || undefined);
            toast.success('Hesap oluşturuldu');
            nav('/');
        } catch (err) {
            toast.error(authErrorMessage(err, 'Kayıt başarısız'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen w-full flex items-center justify-center relative"
            style={{ backgroundImage: `url(${BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
            <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm" />
            <div className="relative w-full max-w-md px-6">
                <div className="flex items-center gap-2 mb-8">
                    <TerminalSquare className="h-5 w-5 text-emerald-400" />
                    <span className="text-xs uppercase tracking-[0.25em] text-slate-300">Crypto Decision Support</span>
                </div>

                <div className="border border-slate-700 bg-slate-800 rounded-md p-6 sm:p-8">
                    <h1 className="text-2xl font-semibold tracking-tight text-slate-50 mb-1">Hesap Oluştur</h1>
                    <p className="text-sm text-slate-400 mb-6">Top 100 tarama ve Türkçe raporlara anında erişim.</p>

                    <form onSubmit={onSubmit} className="space-y-4" data-testid="signup-form">
                        <div>
                            <Label className="text-xs text-slate-300 mb-1.5 block uppercase tracking-wider">Ad (opsiyonel)</Label>
                            <Input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                data-testid="signup-name-input"
                                className="bg-slate-900 border-slate-700 h-10 rounded-sm"
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-slate-300 mb-1.5 block uppercase tracking-wider">Email</Label>
                            <Input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="signup-email-input"
                                className="bg-slate-900 border-slate-700 h-10 rounded-sm"
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-slate-300 mb-1.5 block uppercase tracking-wider">Şifre (min 6)</Label>
                            <Input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                minLength={6}
                                data-testid="signup-password-input"
                                className="bg-slate-900 border-slate-700 h-10 rounded-sm"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            data-testid="signup-submit-button"
                            className="w-full bg-emerald-500 text-white hover:bg-emerald-400 h-10 rounded-sm font-medium"
                        >
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Hesap Oluştur'}
                        </Button>
                    </form>

                    <div className="mt-6 pt-6 border-t border-slate-700/50 flex items-center justify-between text-sm">
                        <span className="text-slate-400">Zaten hesabın var mı?</span>
                        <Link to="/login" className="text-slate-100 hover:text-white hover:underline" data-testid="login-link">
                            Giriş yap
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
